import { ref, getDownloadURL } from 'firebase/storage'
import { doc, collection, setDoc, serverTimestamp } from 'firebase/firestore'
import { storage, db } from './firebase'
import { uploadFile } from './uploadFile'

interface UploadAttachmentParams {
    file: File
    workspaceId: string
    userId: string
    taskId?: string
    projectId?: string
}

interface UploadAttachmentResult {
    id: string
    url: string
}

export async function uploadAttachment({ file, workspaceId, userId, taskId, projectId }: UploadAttachmentParams): Promise<UploadAttachmentResult> {
    const attachmentRef = doc(collection(db, 'attachments'))
    const attachmentId = attachmentRef.id
    const storagePath = `attachments/${workspaceId}/${attachmentId}`

    const storageRef = ref(storage, storagePath)
    await uploadFile(storageRef, file)

    const url = await getDownloadURL(storageRef)

    await setDoc(attachmentRef, {
        workspaceId,
        ...(projectId && { projectId }),
        ...(taskId && { taskId }),
        url,
        storagePath,
        name: file.name,
        size: file.size,
        contentType: file.type,
        uploadedBy: userId,
        createdAt: serverTimestamp()
    })

    return { id: attachmentId, url }
}
